// menu/menuConfig.js

const menuConfig = [

  // -----------------------------------
  // ORGANIZATION
  // -----------------------------------

  {
    type: 'groupSingle',

    label: 'Organizations',

    path: '/orgs',

    roles: [
      'superadmin',
      'org:admin'
    ]
  },

  { type: 'separator' },
  {
    type: 'group',
    label: 'Platform Admin',
    roles: [
      'org:user',
      'org:admin',
      'superadmin'
    ],
    children: [
      { label: 'Organizations', path: '/trust/platform/organizations', roles: ['org:user', 'org:admin', 'superadmin']  },
      { label: 'Authorities', path: '/trust/platform/authorities', roles: ['org:user', 'org:admin', 'superadmin']  },
    ]
  },
  {
    type: 'group',
    label: 'Application Setup',
    roles: [
      'org:user',
      'org:admin',
      'superadmin'
    ],
    children: [
      { label: 'Applications', path: '/trust/platform/applications', roles: ['org:user', 'org:admin', 'superadmin']  },
      { label: 'Roles', path: '/trust/platform/roles', roles: ['org:user', 'org:admin', 'superadmin']  },
      { label: 'Participants', path: '/trust/platform/participants', roles: ['org:user', 'org:admin', 'superadmin']  },
      { label: 'Portal Experiences', path: '/portal-experiences', roles: ['org:user', 'org:admin', 'superadmin']  },
      { label: 'Partner Integrations', path: '/partner-integrations', roles: ['org:user', 'org:admin', 'superadmin']  },
      { label: 'Application Builder', path: '/app-builder', roles: ['org:user', 'org:admin', 'superadmin']  },

    ]
  },
  {
    type: 'group',
    label: 'Credential Management',
    roles: [
      'org:user',
      'org:admin',
      'superadmin'
    ],
    children: [
      { label: 'Cardholders', path: '/credentials/cardholders', roles: ['org:user', 'org:admin', 'superadmin']  },
      { label: 'Credentials', path: '/credentials/credentials', roles: ['org:user', 'org:admin', 'superadmin']  },
    ]
  },
  {
    type: 'group',
    label: 'Runtime',
    roles: [
      'org:user',
      'org:admin',
      'superadmin'
    ],
    children: [
      { label: 'Transactions', path: '/runtime/transactions', roles: ['org:user', 'org:admin', 'superadmin']  },
      { label: 'Test Console', path: '/runtime/test-console', roles: ['org:user', 'org:admin', 'superadmin']  },
      { label: 'QR Generator', path: '/dev/tx-qr', roles: ['org:user', 'org:admin', 'superadmin']  },
    ]
  },
  {
    type: 'group',
    label: 'Network Devices',
    roles: [
      'org:user',
      'org:admin',
      'superadmin'
    ],
    children: [
      { label: 'Device Types', path: '/terminals/types', roles: ['org:user', 'org:admin', 'superadmin']  },
      { label: 'Devices', path: '/terminals', roles: ['org:user', 'org:admin', 'superadmin']  },
      { label: 'Device Policies', path: '/terminals/policies', roles: ['org:user', 'org:admin', 'superadmin']  },
    ]
  },

  {
    type: 'group',
    label: 'Certification / Trust',
    roles: [
      'org:user',
      'org:admin',
      'superadmin'
    ],
    children: [
      { label: 'Keys', path: '/crypto/keys', roles: ['org:user', 'org:admin', 'superadmin']  },
      { label: 'Certificates', path: '/crypto/certificates', roles: ['org:user', 'org:admin', 'superadmin'] },
      { label: 'Issue Certificate', path: '/crypto/certificates/issue', roles: ['org:user', 'org:admin', 'superadmin'] },
      { label: 'Verify Entity', path: '/crypto/verify-entity', roles: ['org:user', 'org:admin', 'superadmin'] },
      { label: 'Sign / Verify', path: '/crypto/sign-verify', roles: ['org:user', 'org:admin', 'superadmin'] },
      { label: 'Audit', path: '/crypto/audit', roles: ['org:user', 'org:admin', 'superadmin'] },
    ]
  },
  {
    type: 'groupSingle',

    label: 'Projects',

    path: '/datasets',

    roles: [
      'Admin',
      'org:admin',
      'superadmin'
    ],

    children: [

    ]
  },
  { type: 'separator' },

  // -----------------------------------
  // ASSETS
  // -----------------------------------

  {
    type: 'group',

    label: 'Design Tools',

    roles: [
      'org:admin',
      'superadmin'
    ],

    children: [
      {
        label: 'Landing Pages',
        path: '/lpages',
        roles: [
          'Admin',
          'org:admin',
          'superadmin'
        ]
      },

      {
        label: 'Card Designs',

        path: '/cards',

        roles: [
          'Admin',
          'org:admin',
          'superadmin'
        ]
      },

      {
        label: 'Media Library',

        path: '/mediapage',

        roles: [
          'Admin',
          'org:admin',
          'superadmin'
        ]
      },

      {
        label: 'Project Templates',

        path: '/templates/fieldtemplateList',

        roles: [
          'Admin',
          'org:admin',
          'superadmin'
        ]
      }

    ]
  },
  { type: 'separator' },

  // -----------------------------------
  // Operations
  // -----------------------------------

  {
    type: 'group',

    label: 'Operations',

    roles: [
      'org:user',
      'org:admin',
      'org:owner',
      'superadmin'
    ],

    children: [

      { label: 'Data Records', path: '/datasets/datadoclist', roles: ['org:user', 'org:admin', 'superadmin'], requiresOrg: true },
      { label: 'Printers', path: '/printers', roles: ['org:user', 'org:admin', 'org:owner', 'superadmin'] },
      { label: 'Printer Groups', path: '/printergroups', roles: ['org:user', 'org:admin', 'org:owner', 'superadmin'] },
      { label: 'Bureau Print', path: '/bureau-print', roles: ['superadmin'] },

    ]
  },

  // -----------------------------------
  // Applicatoins
  // -----------------------------------

  {
    type: 'group',

    label: 'Applications',

    roles: [
      'org:user',
      'org:admin',
      'org:owner',
      'superadmin'
    ],

    children: [
      { label: 'Live Gallery', path: '/gallery/datasets', roles: [ 'org:user', 'org:admin', 'superadmin' ]},
      { label: 'Results Portal', path: '/results/datasets', roles: [ 'org:admin', 'org:owner', 'superadmin' ], requiresOrg: true },
      { label: 'Games', path: '/game', roles: ['org:user', 'org:admin', 'superadmin'], requiresOrg: true },
    ]
  },


  { type: 'separator' },

  // -----------------------------------
  // ADMIN
  // -----------------------------------

  {
    type: 'group',
    label: 'Admin',
    roles: [
            'org:admin',
      'org:owner',
      'superadmin'
    ],

    children: [
      { label: 'Branding Sites', path: '/admin/branding', roles: ['org:user', 'org:admin', 'superadmin']},
      { label: 'Print Devices', path: '/devices', roles: ['org:admin', 'org:owner', 'superadmin'], requiresOrg: true },
      // children: [
      //   { label: 'Live Gallery', path: '/gallery/datasets', roles: [ 'org:user', 'org:admin', 'superadmin' ]},
      //   { label: 'Results Portal', path: '/results/datasets', roles: [ 'org:user', 'org:admin', 'superadmin' ]},
      //   { label: 'Games', path: '/game', roles: ['org:user', 'org:admin', 'superadmin'], requiresOrg: true },
      // ]
    ]
  }

];

export default menuConfig;
